import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {StyledPaymentSuccessMessage} from './StyledPaymentSuccessMessage';
import {ReactComponent as SuccessSvgImage} from '../../static/images/success.svg';

const PaymentSuccessMessage = ({ title, description, onClose }) => {
  const [trans] = useTranslation(['main', 'transactions']);

  const t = (key) => trans(`transactions:modal.paymentSubmittedSuccessfully.${key}`);

  return (
    <StyledPaymentSuccessMessage
      icon={<SuccessSvgImage />}
      title={title || t('title')}
      subTitle={description || t('description')}
      extra={[
        <Button type='primary' key='close' onClick={onClose}>
          {trans('close')}
        </Button>,
      ]}
    />
  );
};

PaymentSuccessMessage.propTypes = {
  description: PropTypes.string,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

export default PaymentSuccessMessage;
